import { Tooltip } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { OmnisearchGridColDef } from "hooks/useOmnisearchDatagrid";

import type { Row } from "./Manifests";

import { ShipmentReconciliationChip } from "../Shipments/ShipmentReconciliationChip";

/**
 * Whether the shipment this manifest was attached to still agrees with it.
 *
 * Spread into the column list so it disappears entirely for tenants without
 * container tracking — this grid is not flag-gated at the route, so an
 * always-empty column would otherwise show for every waste tenant.
 *
 * Neither sortable nor filterable: reconciliation is computed at read, so there
 * is no stored column for the database to order or filter on.
 */
export function reconciliationColumn(enabled: boolean): OmnisearchGridColDef<Row>[] {
  if (!enabled) {
    return [];
  }
  return [
    {
      field: "reconciliation" as const,
      headerName: "Reconciliation",
      flex: 0.8,
      // Same labels as the shipments grid, so the same floor.
      minWidth: 180,
      sortable: false,
      filterable: false,
      renderCell: ({ row }: GridRenderCellParams<Row>) => {
        const status = row.linkedShipment?.reconciliation.status;
        if (!status) {
          return null;
        }
        return (
          <Tooltip
            title={
              row.linkedShipment?.manifestRequestNumber
                ? `Attached to ${row.linkedShipment.manifestRequestNumber}`
                : ""
            }
          >
            <span>
              <ShipmentReconciliationChip status={status} />
            </span>
          </Tooltip>
        );
      },
    },
  ];
}
